module.exports = __webpack_public_path__ + "static/media/home-automation.d69ad509.png";